import React from "react";
import "./Dates.css";

const DateToday = () => {
  const today = new Date();
  return (
    <div className="dateToday">
      <span className="date">{today.toDateString()}</span>
    </div>
  );
};

export default DateToday;
